import React from 'react';
import {useTheme} from '@mui/material';

import {FullscreenLoadingProps} from './types';
import {Loading} from '../Loading';

export function FullscreenLoading({text}: FullscreenLoadingProps) {
	const {palette} = useTheme();

	return (
		<Loading
			text={text}
			textColor={palette.other.progressBar}
			minHeight="100%"
			sx={{color: palette.other.progressBar}}
			thickness={6}
			boxProps={{
				bgcolor: palette.primary.main,
				minHeight: '100vh',
				justifyContent: 'center',
				position: 'fixed',
				zIndex: 9999,
				top: 0,
				left: 0,
			}}
		/>
	);
}
